import type { CustomerRespondPushData } from '@entities/customer'
import type { ApiResponse } from '@shared/api'

import { useCustomerStore } from '@entities/customer'
import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

/** `POST /admin-api/customers/{customer}/respond-push` — creates or updates the Respond.io contact. */
export const useCustomerRespondPushApi = async (customerId: number): Promise<CustomerRespondPushData | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const customerStore = useCustomerStore()

  const url = useAdminRoutes('admin.customer.respond-push', { customer_id: customerId })

  customerStore.trackProcessing(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.post<ApiResponse>(url)
    const respond: CustomerRespondPushData | null = data.data || null

    if (!data.success || !respond) {
      toast.error(data.message)
      return null
    }

    return respond
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return null
  } finally {
    customerStore.trackProcessing(false)
  }
}
